import React, { useContext, useState } from "react";
import { Icons } from "../../assets";
import { Mention, MentionsInput, SuggestionDataItem } from "react-mentions";
import { Strings } from "../../constants";
import { isMobile, specialCharsRegex } from "../../utils";
import { AccountContext, AccountContextInterface } from "../../contexts";
import { POST_RECCO_STEPS } from "../../types";
import { Uploader } from "rsuite";
import "rsuite/Uploader/styles/index.css";
import { FileType } from "rsuite/esm/Uploader";

type MediaType = {
  uri: string;
  width?: number;
  height?: number;
  isVideo?: boolean;
  [key: string]: any;
};

type Props = {
  reccoText: string;
  setStep: (newStep: POST_RECCO_STEPS) => void;
  setReccoText: (text: string) => void;
  reccoResources: FileType[];
  setReccoResources: (files: FileType[]) => void;
};

export const PostRecco: React.FC<Props> = ({
  setStep,
  reccoText,
  setReccoText,
  reccoResources,
  setReccoResources,
}) => {
  const { accountService } = useContext<AccountContextInterface>(AccountContext);
  const [mediaUrls, setMediaUrls] = useState<MediaType[]>([]);

  const fetchHashtags = async (query: string, callback: (data: SuggestionDataItem[]) => void) => {
    if (!query || query.match(specialCharsRegex)?.length) return;
    const { data, error } = await accountService.getHashtagSuggestions(query);
    if (data && !error) {
      callback(data.map((t) => ({ display: t, id: t })));
    }
  };

  return (
    <div className="w-full max-w-2xl mx-auto p-6">
      <p className="text-lg font-semibold">{Strings.POST_RECCO}</p>

      <div className="w-full mt-3">
        <MentionsInput
          value={reccoText}
          onChange={(_e, _text, plainText: string) => setReccoText(plainText)}
          className="editor"
          placeholder={Strings.RECCO_PLACEHOLDER}
          singleLine={false}
        >
          <Mention
            trigger="#"
            data={fetchHashtags}
            appendSpaceOnAdd
            renderSuggestion={(_suggestion, _search, highlightedTag) => (
              <div className="flex items-center gap-2">
                <img src={Icons.HASHTAG} alt="" className="w-4 h-4" />
                <span>{highlightedTag}</span>
              </div>
            )}
          />
        </MentionsInput>
      </div>

      <div className="mb-24">
          <div>
            <Uploader
              style={{ border: 'none', marginTop: '16px' }}
              multiple
              autoUpload={false}
              action="//jsonplaceholder.typicode.com/posts/"
              draggable
              listType="picture-text"
              onChange={(fileList: FileType[], event: React.ChangeEvent<Element> | React.MouseEvent<Element, MouseEvent>) => {
                setReccoResources(fileList);
              }}
              onSuccess={(response) => {
                if (response && response.url) {
                  const newFile = {
                    uri: response.url,
                    width: 0,
                    height: 0,
                    isVideo: response.url.endsWith('.mp4'),
                  };
                  setMediaUrls((prev) => [...prev, newFile]);
                }
              }}
            >
              <div className='' style={{ height: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent' }}>
                <div className="file-picker-wrapper file-picker-icon">
                  <img src={Icons.ADD_FILE_ICON} alt='' />
                </div>
              </div>
            </Uploader>
          </div>
        </div>

      <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 w-full max-w-md px-4">
        <button
          className={`w-full btn btn-primary fw-bold rounded-full ${isMobile() ? 'w-full' : 'w-1/2'} max-w-md`}
          disabled={!reccoText.length}
          onClick={() => setStep(POST_RECCO_STEPS.VERIFY)}
        >
          {Strings.POST_RECCO_BUTTON_TEXT}
        </button>
      </div>
    </div>
  );
};
